import React from 'react';
import { Card } from '@/components/ui/card';
import { getSubjectColor } from './subjectColor';

export const CalendarGridView = ({ days, periods, calendarLookup }) => (
  <Card className="p-4 sm:p-6" data-testid="calendar-view">
    <div className="overflow-x-auto">
      <table className="w-full text-xs sm:text-sm border-collapse" data-testid="calendar-grid-table">
        <thead>
          <tr>
            <th className="p-2 text-left font-medium text-slate-500 border-b-2 border-slate-300 w-24"></th>
            {days.map(day => (
              <th key={day} className="p-2 text-center font-semibold text-slate-700 border-b-2 border-slate-300" style={{ minWidth: '140px' }}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {periods.map(period => (
            <tr key={period}>
              <td className="p-2 font-medium text-slate-600 border-b border-slate-100 whitespace-nowrap align-top">{period}</td>
              {days.map(day => {
                const entries = calendarLookup[`${day}-${period}`] || [];
                return (
                  <td key={day} className="p-1.5 border-b border-slate-100 align-top" style={{ minWidth: '140px' }}>
                    {entries.length > 0 ? entries.map(entry => (
                      <div key={entry.id} className={`px-2 py-1.5 rounded border mb-1 ${getSubjectColor(entry.subject)}`}>
                        <p className="font-semibold text-xs">{entry.class_name} - {entry.subject}</p>
                        <p className="text-xs opacity-70">{entry.teacher_name}</p>
                        {entry.time_slot && <p className="text-xs opacity-50">{entry.time_slot}</p>}
                      </div>
                    )) : (
                      <div className="px-2 py-1.5 text-center text-slate-300">-</div>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Card>
);
